import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import { store } from '../../store/store';
import { Provider } from 'react-redux';
import AclContextProvider from '../../Modules/Acl/Components/AclContextProvider';
import WorkplaceCalendarWithFilter from '../../Modules/Calendar/Components/WorkplaceCalendar/WorkplaceCalendarWithFilter';

loadDOMComponent({
	selector: 'react-workplace-calendar',
	callback: ({ container }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const patientId = container.getAttribute('patientId');
		const params = JSON.parse(container.getAttribute('params'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<WorkplaceCalendarWithFilter
							workplaceId={workplaceId}
							patientId={patientId}
							params={params}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
